// src/constants/fonts.js

const CHARWIDTHS = {
  A: 1.5,
  B: 1.4,
  C: 1.3,
  D: 1.4,
  E: 1.3,
  F: 1.2,
  G: 1.4,
  H: 1.5,
  I: 0.6,
  J: 1.1,
  K: 1.4,
  L: 1.2,
  M: 1.8,
  N: 1.5,
  O: 1.5,
  P: 1.3,
  Q: 1.5,
  R: 1.4,
  S: 1.3,
  T: 1.2,
  U: 1.5,
  V: 1.4,
  W: 2.0,
  X: 1.4,
  Y: 1.3,
  Z: 1.3,
  a: 1.0,
  b: 1.0,
  c: 0.9,
  d: 1.0,
  e: 0.9,
  f: 0.7,
  g: 1.0,
  h: 1.0,
  i: 0.4,
  j: 0.6,
  k: 1.0,
  l: 0.5,
  m: 1.5,
  n: 0.9,
  o: 1.0,
  p: 1.0,
  q: 1.0,
  r: 0.8,
  s: 0.9,
  t: 0.7,
  u: 1.0,
  v: 0.9,
  w: 1.3,
  x: 0.9,
  y: 1.0,
  z: 0.9,
  0: 1.0,
  1: 0.75,
  2: 1.0,
  3: 1.0,
  4: 1.0,
  5: 1.0,
  6: 1.0,
  7: 1.0,
  8: 1.0,
  9: 1.0,
  "&": 1.2,
  ",": 0.5,
  ".": 0.5,
  "-": 0.8,
};

const CHARSET =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&-$* \\s";

const UPPERCHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789,.'&-$* \\s";

const SIZEMAP = [
  { code: "01", height: 1.0, name: "1 inch" },
  { code: "02", height: 2.0, name: "2 inch" },
  { code: "03", height: 3.0, name: "3 inch" },
  { code: "04", height: 4.0, name: "4 inch" },
  { code: "05", height: 5.0, name: "5 inch" },
  { code: "06", height: 6.0, name: "6 inch" },
  { code: "07", height: 7.0, name: "7 inch" },
  { code: "08", height: 8.0, name: "8 inch" },
  { code: "09", height: 9.0, name: "9 inch" },
  { code: "10", height: 10.0, name: "10 inch" },
  { code: "11", height: 11.0, name: "11 inch" },
  { code: "12", height: 12.0, name: "12 inch" },
];

const FLATCUTFONTS = [
  {
    name: "Ubuntu",
    code: "Ubuntu",
    path: "/fonts/Ubuntu-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.773,
  },
  {
    name: "Abril Fatface",
    code: "Abril_Fatface",
    path: "/fonts/AbrilFatface-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.763,
  },
  {
    name: "Acme",
    code: "Acme",
    path: "/fonts/Acme-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.648,
  },
  {
    name: "Alba Matter",
    code: "Alba_Matter",
    path: "/fonts/albam_.ttf",
    format: "truetype",
    upcharge: 1.35,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.606,
  },
  {
    name: "Alfa Slab",
    code: "Alfa_Slab",
    path: "/fonts/AlfaSlabOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.794,
  },
  {
    name: "Americana",
    code: "Americana",
    path: "/fonts/GT-Americana_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.993,
  },
  {
    name: "Antique Olive",
    code: "Antique_Olive",
    path: "/fonts/GT-AntiqueOliveMedium.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.729,
  },
  {
    name: "Anton",
    code: "Anton",
    path: "/fonts/Anton-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.485,
  },
  {
    name: "Antonio",
    code: "Antonio",
    path: "/fonts/Antonio-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.441,
  },
  {
    name: "Architectural",
    code: "Architectural",
    path: "/fonts/GT-Architectural_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.762,
  },
  {
    name: "Archivo Narrow",
    code: "Archivo_Narrow",
    path: "/fonts/ArchivoNarrow-Medium.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.62,
  },
  {
    name: "Arial",
    code: "Arial",
    path: "/fonts/GT-Arial_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.723,
  },
  {
    name: "Arial Bold",
    code: "Arial_Bold",
    path: "/fonts/GT-Arial_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: UPPERCHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.755,
  },
  {
    name: "Audiowide",
    code: "Audiowide",
    path: "/fonts/Audiowide-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.904,
  },
  {
    name: "Avant Extra Bold",
    code: "Avant_Extra_Bold",
    path: "/fonts/GT-Avant_Extra_Bold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.763,
  },
  {
    name: "Avant Garde Medium",
    code: "Avant_Garde_Medium",
    path: "/fonts/GT-Avant_Garde_Medium_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.777,
  },
  {
    name: "Balthazer",
    code: "Balthazer",
    path: "/fonts/Balthazar-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.725,
  },
  {
    name: "Bauhaus",
    code: "Bauhaus",
    path: "/fonts/GT-Bauhaus.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.675,
  },
  {
    name: "Bangers",
    code: "Bangers",
    path: "/fonts/Bangers-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.514,
  },
  {
    name: "Barlow Condensed",
    code: "Barlow_Condensed",
    path: "/fonts/BarlowCondensed-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.544,
  },
  {
    name: "Bebas",
    code: "Bebas",
    path: "/fonts/BebasNeue-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.537,
  },
  {
    name: "Benguiat",
    code: "Benguiat",
    path: "/fonts/GT-Benguiat_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.752,
  },
  {
    name: "Berkshire Swash",
    code: "Berkshire_Swash",
    path: "/fonts/BerkshireSwash-Regular.ttf",
    format: "truetype",
    upcharge: 1.5,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.699,
  },
  {
    name: "Bodoni Italic",
    code: "Bodoni_Italic",
    path: "/fonts/LibreBodoni-SemiBoldItalic.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: UPPERCHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.962,
  },
  {
    name: "Brush Script",
    code: "Brush_Script",
    path: "/fonts/GT-Brush_Script_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.66,
  },
  {
    name: "Caprasimo",
    code: "Caprasimo",
    path: "/fonts/Caprasimo-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.873,
  },
  {
    name: "Casual Italic",
    code: "Casual_Italic",
    path: "/fonts/GT-Casual_Italic_Script.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.584,
  },
  {
    name: "Century Bold Condensed",
    code: "Century_Bold_Condensed",
    path: "/fonts/GT-Century_Bold_Cond.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.539,
  },
  {
    name: "Century Schoolbook",
    code: "Century_Schoolbook",
    path: "/fonts/Domine-SemiBold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: UPPERCHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.966,
  },
  {
    name: "Clarendon Bold",
    code: "Clarendon_Bold",
    path: "/fonts/GT-Clarendon_Fortune_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: UPPERCHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.852,
  },
  {
    name: "Clarion",
    code: "Clarion",
    path: "/fonts/GT-Clarion.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: UPPERCHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 1.179,
  },
  {
    name: "Clearview Light",
    code: "Clearview_Light",
    path: "/fonts/GT-ClearviewOneLight.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.692,
  },
  {
    name: "Clearview Bold",
    code: "Clearview_Bold",
    path: "/fonts/GT-ClearviewOneBold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.828,
  },
  {
    name: "Consort",
    code: "Consort",
    path: "/fonts/GT-Consort.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.863,
  },
  {
    name: "Cookie",
    code: "Cookie",
    path: "/fonts/Cookie-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.606,
  },
  {
    name: "Country Gothic",
    code: "Country_Gothic",
    path: "/fonts/GT-Country_Gothic.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.716,
  },
  {
    name: "Creepster",
    code: "Creepster",
    path: "/fonts/Creepster-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.528,
  },
  {
    name: "Crushed",
    code: "Crushed",
    path: "/fonts/Creepster-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.546,
  },
  {
    name: "Exo Bold",
    code: "Exo_Bold",
    path: "/fonts/Exo2-Bold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.757,
  },
  {
    name: "Fjalla",
    code: "Fjalla",
    path: "/fonts/FjallaOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.498,
  },
  {
    name: "Fontdiner Swanky",
    code: "Fontdiner_Swanky",
    path: "/fonts/FontdinerSwanky-Regular.ttf",
    format: "truetype",
    upcharge: 1.5,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.914,
  },
  {
    name: "Friz Quadrata",
    code: "Friz_Quadrata",
    path: "/fonts/GT-Friz_Quadrata_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.743,
  },
  {
    name: "Futura",
    code: "Futura",
    path: "/fonts/Jost-Medium.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.752,
  },
  {
    name: "Futura Bold",
    code: "Futura_Bold",
    path: "/fonts/Jost-Bold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.875,
  },
  {
    name: "Futura Condensed",
    code: "Futura_Condensed",
    path: "/fonts/GT-Futura_Condensed_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.545,
  },
  {
    name: "Futura Demibold",
    code: "Futura_Demibold",
    path: "/fonts/Jost-SemiBold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.704,
  },
  {
    name: "Gemco",
    code: "Gemco",
    path: "/fonts/GT-Gemco.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: UPPERCHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.705,
  },
  {
    name: "Grand Hotel",
    code: "Grand_Hotel",
    path: "/fonts/GrandHotel-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.518,
  },
  {
    name: "Helvetica",
    code: "Helvetica",
    path: "/fonts/GT-Helvetica_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.815,
  },
  {
    name: "Helvetica Bold",
    code: "Helvetica_Bold",
    path: "/fonts/GT-Helvetica_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: "^[A-Za-z0-9,.'&\\-$*s]*$",
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.96,
  },
  {
    name: "Helvetica Medium Condensed",
    code: "Helvetica_Medium_Condensed",
    path: "/fonts/GT-Helvetica_Medium_Cond_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.674,
  },
  {
    name: "Herman Italic",
    code: "Herman_Italic",
    path: "/fonts/GT-Herman_Italic.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.817,
  },
  {
    name: "Holtwood One",
    code: "Holtwood_One",
    path: "/fonts/HoltwoodOneSC-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.992,
  },
  {
    name: "Impact",
    code: "Impact",
    path: "/fonts/impact.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.551,
  },
  {
    name: "Italicized Script",
    code: "Italicized_Script",
    path: "/fonts/GT-Italicized_Script.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.643,
  },
  {
    name: "Kavoon",
    code: "Kavoon",
    path: "/fonts/Kavoon-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.693,
  },
  {
    name: "Lato Bold",
    code: "Lato_Bold",
    path: "/fonts/Lato-Bold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.728,
  },
  {
    name: "Leckerli One",
    code: "Leckerli_One",
    path: "/fonts/LeckerliOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.685,
  },
  {
    name: "Lily Script One",
    code: "Lily_Script_One",
    path: "/fonts/LilyScriptOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.5,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.649,
  },
  {
    name: "Limelight",
    code: "Limelight",
    path: "/fonts/Limelight-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.822,
  },
  {
    name: "Lobster",
    code: "Lobster",
    path: "/fonts/Lobster-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.613,
  },
  {
    name: "Luckiest Guy",
    code: "Luckiest_Guy",
    path: "/fonts/LuckiestGuy-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.732,
  },
  {
    name: "Magneto",
    code: "Magneto",
    path: "/fonts/magnetob.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.887,
  },
  {
    name: "Mystery Quest",
    code: "Mystery_Quest",
    path: "/fonts/MysteryQuest-Regular.ttf",
    format: "truetype",
    upcharge: 1.5,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.594,
  },
  {
    name: "Nerko One",
    code: "Nerko_One",
    path: "/fonts/NerkoOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.69,
  },
  {
    name: "Norwester",
    code: "Norwester",
    path: "/fonts/norwester.otf",
    format: "otf",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.566,
  },
  {
    name: "Nova Square",
    code: "Nova_Square",
    path: "/fonts/NovaSquare-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.682,
  },
  {
    name: "Oleo Script",
    code: "Oleo_Script",
    path: "/fonts/OleoScript-Bold.ttf",
    format: "truetype",
    upcharge: 1.5,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.627,
  },
  {
    name: "Optima",
    code: "Optima",
    path: "/fonts/GT-Optima_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.686,
  },
  {
    name: "Optima Semibold",
    code: "Optima_Semibold",
    path: "/fonts/GT-Optima_Semibold_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.73,
  },
  {
    name: "Oswald",
    code: "Oswald",
    path: "/fonts/Oswald-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.545,
  },
  {
    name: "Pacifico",
    code: "Pacifico",
    path: "/fonts/Pacifico-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.643,
  },
  {
    name: "Palatino",
    code: "Palatino",
    path: "/fonts/Merriweather-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.746,
  },
  {
    name: "Palatino Semibold",
    code: "Palatino_Semibold",
    path: "/fonts/Merriweather-Bold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: UPPERCHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.768,
  },
  {
    name: "Peralta",
    code: "Peralta",
    path: "/fonts/Peralta-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.907,
  },
  {
    name: "Perfaire",
    code: "Perfaire",
    path: "/fonts/GT-Perfaire.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.802,
  },
  {
    name: "Permanent Marker",
    code: "Permanent_Marker",
    path: "/fonts/PermanentMarker-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.721,
  },
  {
    name: "Ranchers",
    code: "Ranchers",
    path: "/fonts/Ranchers-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.54,
  },
  {
    name: "Roboto Slab",
    code: "Roboto_Slab",
    path: "/fonts/RobotoSlab-SemiBold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.755,
  },
  {
    name: "Rubik",
    code: "Rubik",
    path: "/fonts/Rubik-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.743,
  },
  {
    name: "Saira Stencil",
    code: "Saira_Stencil",
    path: "/fonts/SairaStencilOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.775,
  },
  {
    name: "Salsa",
    code: "Salsa",
    path: "/fonts/Salsa-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.689,
  },
  {
    name: "Sarina",
    code: "Sarina",
    path: "/fonts/Sarina-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 1.001,
  },
  {
    name: "Satisfy",
    code: "Satisfy",
    path: "/fonts/Satisfy-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.466,
  },
  {
    name: "Shojumaru",
    code: "Shojumaru",
    path: "/fonts/Shojumaru-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.959,
  },
  {
    name: "Short Stack",
    code: "Short_Stack",
    path: "/fonts/ShortStack-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.746,
  },
  {
    name: "Sofia",
    code: "Sofia",
    path: "/fonts/Sofia-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.721,
  },
  {
    name: "Standard Block",
    code: "Standard_Block",
    path: "/fonts/GT-Standard_Block_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.644,
  },
  {
    name: "Standard Block Condensed",
    code: "Standard_Block_Condensed",
    path: "/fonts/GT-Standard_Block_Cond.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: UPPERCHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.515,
  },
  {
    name: "Times Roman",
    code: "Times_Roman",
    path: "/fonts/GT-Times_Roman.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.763,
  },
  {
    name: "Titillium Web",
    code: "Titillium_Web",
    path: "/fonts/TitilliumWeb-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.713,
  },
  {
    name: "Custom Font File",
    code: "Custom_Font_File",
    path: "/fonts/GT-Arial_v2.ttf",
    format: "truetype",
    upcharge: 1.5,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 1.0,
  },
];

const MLFONTS = [
  {
    name: "Helvetica",
    code: "Helvetica",
    path: "/fonts/GT-Helvetica_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.815,
  },
  {
    name: "Architectural",
    code: "Architectural",
    path: "/fonts/GT-Architectural_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZ0123456789,.'&\\-$* \\s",
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.762,
  },
  {
    name: "Times Bold",
    code: "Times_Bold",
    path: "/fonts/GT-Times_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.775,
  },
];

const BL10FONTS = [
  {
    name: "Helvetica",
    code: "Helvetica",
    path: "/fonts/GT-Helvetica_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.815,
  },
  {
    name: "Ubuntu",
    code: "Ubuntu",
    path: "/fonts/Ubuntu-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.773,
  },
  {
    name: "Abril Fatface",
    code: "Abril_Fatface",
    path: "/fonts/AbrilFatface-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.763,
  },
  {
    name: "Acme",
    code: "Acme",
    path: "/fonts/Acme-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.648,
  },
  {
    name: "Alba Matter",
    code: "Alba_Matter",
    path: "/fonts/albam_.ttf",
    format: "truetype",
    upcharge: 1.55,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.606,
  },
  {
    name: "Alfa Slab",
    code: "Alfa_Slab",
    path: "/fonts/AlfaSlabOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.794,
  },
  {
    name: "Americana",
    code: "Americana",
    path: "/fonts/GT-Americana_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.993,
  },
  {
    name: "Antique Olive",
    code: "Antique_Olive",
    path: "/fonts/GT-AntiqueOliveMedium.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.729,
  },
  {
    name: "Anton",
    code: "Anton",
    path: "/fonts/Anton-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.485,
  },
  {
    name: "Antonio",
    code: "Antonio",
    path: "/fonts/Antonio-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.441,
  },
  {
    name: "Architectural",
    code: "Architectural",
    path: "/fonts/GT-Architectural_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.762,
  },
  {
    name: "Archivo Narrow",
    code: "Archivo_Narrow",
    path: "/fonts/ArchivoNarrow-Medium.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.62,
  },
  {
    name: "Arial",
    code: "Arial",
    path: "/fonts/GT-Arial_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.723,
  },
  {
    name: "Arial Bold",
    code: "Arial_Bold",
    path: "/fonts/GT-Arial_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: UPPERCHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.755,
  },
  {
    name: "Audiowide",
    code: "Audiowide",
    path: "/fonts/Audiowide-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.904,
  },
  {
    name: "Avant Extra Bold",
    code: "Avant_Extra_Bold",
    path: "/fonts/GT-Avant_Extra_Bold.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.763,
  },
  {
    name: "Avant Garde Medium",
    code: "Avant_Garde_Medium",
    path: "/fonts/GT-Avant_Garde_Medium_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.777,
  },
  {
    name: "Balthazer",
    code: "Balthazer",
    path: "/fonts/Balthazar-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.725,
  },
  {
    name: "Bauhaus",
    code: "Bauhaus",
    path: "/fonts/GT-Bauhaus.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.675,
  },
  {
    name: "Bangers",
    code: "Bangers",
    path: "/fonts/Bangers-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.514,
  },
  {
    name: "Barlow Condensed",
    code: "Barlow_Condensed",
    path: "/fonts/BarlowCondensed-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.544,
  },
  {
    name: "Bebas",
    code: "Bebas",
    path: "/fonts/BebasNeue-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.537,
  },
  {
    name: "Benguiat",
    code: "Benguiat",
    path: "/fonts/GT-Benguiat_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.752,
  },
  {
    name: "Berkshire Swash",
    code: "Berkshire_Swash",
    path: "/fonts/BerkshireSwash-Regular.ttf",
    format: "truetype",
    upcharge: 1.7,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.699,
  },
  {
    name: "Bodoni Italic",
    code: "Bodoni_Italic",
    path: "/fonts/LibreBodoni-SemiBoldItalic.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.962,
  },
  {
    name: "Brush Script",
    code: "Brush_Script",
    path: "/fonts/GT-Brush_Script_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.66,
  },
  {
    name: "Caprasimo",
    code: "Caprasimo",
    path: "/fonts/Caprasimo-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.873,
  },
  {
    name: "Casual Italic",
    code: "Casual_Italic",
    path: "/fonts/GT-Casual_Italic_Script.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: UPPERCHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.584,
  },
  {
    name: "Century Bold Condensed",
    code: "Century_Bold_Condensed",
    path: "/fonts/GT-Century_Bold_Cond.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.539,
  },
  {
    name: "Century Schoolbook",
    code: "Century_Schoolbook",
    path: "/fonts/Domine-SemiBold.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.966,
  },
  {
    name: "Clarendon Bold",
    code: "Clarendon_Bold",
    path: "/fonts/GT-Clarendon_Fortune_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: UPPERCHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.852,
  },
  {
    name: "Clarion",
    code: "Clarion",
    path: "/fonts/GT-Clarion.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: UPPERCHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 1.179,
  },
  {
    name: "Clearview Light",
    code: "Clearview_Light",
    path: "/fonts/GT-ClearviewOneLight.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.692,
  },
  {
    name: "Clearview Bold",
    code: "Clearview_Bold",
    path: "/fonts/GT-ClearviewOneBold.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.828,
  },
  {
    name: "Consort",
    code: "Consort",
    path: "/fonts/GT-Consort.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.863,
  },
  {
    name: "Cookie",
    code: "Cookie",
    path: "/fonts/Cookie-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.606,
  },
  {
    name: "Country Gothic",
    code: "Country_Gothic",
    path: "/fonts/GT-Country_Gothic.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.716,
  },
  {
    name: "Creepster",
    code: "Creepster",
    path: "/fonts/Creepster-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.528,
  },
  {
    name: "Crushed",
    code: "Crushed",
    path: "/fonts/Creepster-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.546,
  },
  {
    name: "Exo Bold",
    code: "Exo_Bold",
    path: "/fonts/Exo2-Bold.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.757,
  },
  {
    name: "Fjalla",
    code: "Fjalla",
    path: "/fonts/FjallaOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.498,
  },
  {
    name: "Fontdiner Swanky",
    code: "Fontdiner_Swanky",
    path: "/fonts/FontdinerSwanky-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.914,
  },
  {
    name: "Friz Quadrata",
    code: "Friz_Quadrata",
    path: "/fonts/GT-Friz_Quadrata_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.743,
  },
  {
    name: "Futura",
    code: "Futura",
    path: "/fonts/Jost-Medium.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.752,
  },
  {
    name: "Futura Bold",
    code: "Futura_Bold",
    path: "/fonts/Jost-Bold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.875,
  },
  {
    name: "Futura Condensed",
    code: "Futura_Condensed",
    path: "/fonts/GT-Futura_Condensed_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.545,
  },
  {
    name: "Futura Demibold",
    code: "Futura_Demibold",
    path: "/fonts/Jost-SemiBold.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.704,
  },
  {
    name: "Gemco",
    code: "Gemco",
    path: "/fonts/GT-Gemco.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: UPPERCHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.705,
  },
  {
    name: "Grand Hotel",
    code: "Grand_Hotel",
    path: "/fonts/GrandHotel-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.518,
  },
  {
    name: "Helvetica Bold",
    code: "Helvetica_Bold",
    path: "/fonts/GT-Helvetica_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: "^[A-Za-z0-9,.'&\\-$*s]*$",
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.96,
  },
  {
    name: "Helvetica Medium Condensed",
    code: "Helvetica_Medium_Condensed",
    path: "/fonts/GT-Helvetica_Medium_Cond_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.674,
  },
  {
    name: "Herman Italic",
    code: "Herman_Italic",
    path: "/fonts/GT-Herman_Italic.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.817,
  },
  {
    name: "Holtwood One",
    code: "Holtwood_One",
    path: "/fonts/HoltwoodOneSC-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.992,
  },
  {
    name: "Impact",
    code: "Impact",
    path: "/fonts/impact.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.551,
  },
  {
    name: "Italicized Script",
    code: "Italicized_Script",
    path: "/fonts/GT-Italicized_Script.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.643,
  },
  {
    name: "Kavoon",
    code: "Kavoon",
    path: "/fonts/Kavoon-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.693,
  },
  {
    name: "Lato Bold",
    code: "Lato_Bold",
    path: "/fonts/Lato-Bold.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.728,
  },
  {
    name: "Leckerli One",
    code: "Leckerli_One",
    path: "/fonts/LeckerliOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.685,
  },
  {
    name: "Lily Script One",
    code: "Lily_Script_One",
    path: "/fonts/LilyScriptOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.649,
  },
  {
    name: "Limelight",
    code: "Limelight",
    path: "/fonts/Limelight-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.822,
  },
  {
    name: "Lobster",
    code: "Lobster",
    path: "/fonts/Lobster-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.613,
  },
  {
    name: "Luckiest Guy",
    code: "Luckiest_Guy",
    path: "/fonts/LuckiestGuy-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.732,
  },
  {
    name: "Magneto",
    code: "Magneto",
    path: "/fonts/magnetob.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.887,
  },
  {
    name: "Mystery Quest",
    code: "Mystery_Quest",
    path: "/fonts/MysteryQuest-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.594,
  },
  {
    name: "Nerko One",
    code: "Nerko_One",
    path: "/fonts/NerkoOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.69,
  },
  {
    name: "Norwester",
    code: "Norwester",
    path: "/fonts/norwester.otf",
    format: "otf",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.566,
  },
  {
    name: "Nova Square",
    code: "Nova_Square",
    path: "/fonts/NovaSquare-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.682,
  },
  {
    name: "Oleo Script",
    code: "Oleo_Script",
    path: "/fonts/OleoScript-Bold.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.627,
  },
  {
    name: "Optima",
    code: "Optima",
    path: "/fonts/GT-Optima_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.686,
  },
  {
    name: "Optima Semibold",
    code: "Optima_Semibold",
    path: "/fonts/GT-Optima_Semibold_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.73,
  },
  {
    name: "Oswald",
    code: "Oswald",
    path: "/fonts/Oswald-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.545,
  },
  {
    name: "Pacifico",
    code: "Pacifico",
    path: "/fonts/Pacifico-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.643,
  },
  {
    name: "Palatino",
    code: "Palatino",
    path: "/fonts/Merriweather-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.746,
  },
  {
    name: "Palatino Semibold",
    code: "Palatino_Semibold",
    path: "/fonts/Merriweather-Bold.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.768,
  },
  {
    name: "Peralta",
    code: "Peralta",
    path: "/fonts/Peralta-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.907,
  },
  {
    name: "Perfaire",
    code: "Perfaire",
    path: "/fonts/GT-Perfaire.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.802,
  },
  {
    name: "Permanent Marker",
    code: "Permanent_Marker",
    path: "/fonts/PermanentMarker-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.721,
  },
  {
    name: "Ranchers",
    code: "Ranchers",
    path: "/fonts/Ranchers-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.54,
  },
  {
    name: "Roboto Slab",
    code: "Roboto_Slab",
    path: "/fonts/RobotoSlab-SemiBold.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.755,
  },
  {
    name: "Rubik",
    code: "Rubik",
    path: "/fonts/Rubik-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.743,
  },
  {
    name: "Saira Stencil",
    code: "Saira_Stencil",
    path: "/fonts/SairaStencilOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.775,
  },
  {
    name: "Salsa",
    code: "Salsa",
    path: "/fonts/Salsa-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.689,
  },
  {
    name: "Sarina",
    code: "Sarina",
    path: "/fonts/Sarina-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 1.001,
  },
  {
    name: "Satisfy",
    code: "Satisfy",
    path: "/fonts/Satisfy-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.466,
  },
  {
    name: "Shojumaru",
    code: "Shojumaru",
    path: "/fonts/Shojumaru-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.959,
  },
  {
    name: "Short Stack",
    code: "Short_Stack",
    path: "/fonts/ShortStack-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.746,
  },
  {
    name: "Sofia",
    code: "Sofia",
    path: "/fonts/Sofia-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.721,
  },
  {
    name: "Standard Block",
    code: "Standard_Block",
    path: "/fonts/GT-Standard_Block_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.644,
  },
  {
    name: "Standard Block Condensed",
    code: "Standard_Block_Condensed",
    path: "/fonts/GT-Standard_Block_Cond.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: UPPERCHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.515,
  },
  {
    name: "Times Bold",
    code: "Times_Bold",
    path: "/fonts/GT-Times_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: "A-Za-z0-9,.'&\\-$\\s",
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.8,
  },
  {
    name: "Times Roman",
    code: "Times_Roman",
    path: "/fonts/GT-Times_Roman.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.763,
  },
  {
    name: "Titillium Web",
    code: "Titillium_Web",
    path: "/fonts/TitilliumWeb-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.713,
  },
  {
    name: "Custom Font File",
    code: "Custom_Font_File",
    path: "/fonts/GT-Arial_v2.ttf",
    format: "truetype",
    upcharge: 1.75,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 1.0,
  },
];

const BL2000FONTS = [
  {
    name: "Helvetica",
    code: "Helvetica",
    path: "/fonts/GT-Helvetica_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.815,
  },
  {
    name: "AMERICANA BOLD",
    code: "Americana_Bold",
    path: "/fonts/GT-Americana_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$*\\s",
    fontAdjustment: 0.99,
    charWidths: CHARWIDTHS,
  },
  {
    name: "ARIAL",
    code: "Arial",
    path: "/fonts/GT-Arial_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.755,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Arial Bold",
    code: "Arial_Bold",
    path: "/fonts/GT-Arial_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.755,
    charWidths: CHARWIDTHS,
  },
  {
    name: "AVANT GARDE MEDIUM",
    code: "Avant_Garde_Medium",
    path: "/fonts/GT-Avant_Garde_Medium_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.777,
    charWidths: CHARWIDTHS,
  },
  {
    name: "CLARENDON MEDIUM",
    code: "Clarendon_Medium",
    path: "/fonts/GT-Clarendon_Medium_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.852,
    charWidths: CHARWIDTHS,
  },
  {
    name: "COPPERPLATE",
    code: "Copperplate",
    path: "/fonts/GT-Copperplate_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "EUROSTYLE BOLD EXTENDED",
    code: "Eurostyle_Bold_Extended",
    path: "/fonts/GT-Eurostyle_Bold_Ext_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "FRIZ QUADRATA",
    code: "Friz_Quadrata",
    path: "/fonts/GT-Friz_Quadrata_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.743,
    charWidths: CHARWIDTHS,
  },
  {
    name: "FUTURA",
    code: "Futura",
    path: "/fonts/GT-Futura_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.752,
    charWidths: CHARWIDTHS,
  },
  {
    name: "FUTURA BOLD",
    code: "Futura_Bold",
    path: "/fonts/GT-Futura_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.875,
    charWidths: CHARWIDTHS,
  },
  {
    name: "GARAMOND BOLD",
    code: "Garamond_Bold",
    path: "/fonts/GT-Garamond_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "GARAMOND REGULAR",
    code: "Garamond_Regular",
    path: "/fonts/GT-Garamond_Regular_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "GIL SANS BOLD",
    code: "Gil_Sans_Bold",
    path: "/fonts/GT-Gil_Sans_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "GOUDY EXTRA BOLD",
    code: "Goudy_Extra_Bold",
    path: "/fonts/GT-GoudyExtraBold_v2.ttf",
    format: "truetype",
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    upcharge: 1.15,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Helvetica Bold",
    code: "Helvetica_Bold",
    path: "/fonts/GT-Helvetica_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.96,
    charWidths: CHARWIDTHS,
  },
  {
    name: "HELVETICA BOLD EXTENDED",
    code: "Helvetica_Bold_Extended",
    path: "/fonts/GT-Helvetica_Bold_Ext.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Helvetica Medium Condensed",
    code: "Helvetica_Medium_Condensed",
    path: "/fonts/GT-Helvetica_Medium_Cond_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.674,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Helvetica Light",
    code: "Helvetica_Light",
    path: "/fonts/GT-Helvetica_Light.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Helvetica Medium Italic",
    code: "Helvetica_Medium_Italic",
    path: "/fonts/GT-Helvetica_Medium_Italic_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "KABEL",
    code: "Kabel",
    path: "/fonts/GT-Kabel_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Optima",
    code: "Optima",
    path: "/fonts/GT-Optima_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.686,
    charWidths: CHARWIDTHS,
  },
  {
    name: "OPTIMA SEMI BOLD",
    code: "Optima_Semi_Bold",
    path: "/fonts/GT-Optima_Semibold_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.645,
    charWidths: CHARWIDTHS,
  },
  {
    name: "PALATINO",
    code: "Palatino",
    path: "/fonts/GT-Palatino_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.746,
    charWidths: CHARWIDTHS,
  },
  {
    name: "PALATINO SEMI BOLD",
    code: "Palatino_Semi_Bold",
    path: "/fonts/GT-Palatino_Semibold_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.768,
    charWidths: CHARWIDTHS,
  },
  {
    name: "RIBBON",
    code: "Ribbon",
    path: "/fonts/GT-Ribbon_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "RIBBON DEEP",
    code: "Ribbon_Deep",
    path: "/fonts/GT-Ribbon_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "RIBBON CONDENSED",
    code: "Ribbon_Condensed",
    path: "/fonts/GT-Ribbon_Condensed_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "ROFFE",
    code: "Roffe",
    path: "/fonts/GT-Roffe_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "A-Z0-9,.'&\\-$\\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Roman",
    code: "Roman",
    path: "/fonts/GT-Roman_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.763,
    charWidths: CHARWIDTHS,
  },
  {
    name: "STANDARD BLOCK",
    code: "Standard_Block",
    path: "/fonts/GT-Standard_Block_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.644,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Times Bold",
    code: "Times_Bold",
    path: "/fonts/GT-Times_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.95,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Times New Roman",
    code: "Times_New_Roman",
    path: "/fonts/GT-Times_New_Roman_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.95,
    charWidths: CHARWIDTHS,
  },
  {
    name: "TWENTIETH CENTURY",
    code: "Twentieth_Century",
    path: "/fonts/GT-Twentieth_Century.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "UNIVERS 67",
    code: "Univers_67",
    path: "/fonts/GT-Univers_67_v2.ttf",
    format: "truetype",
    upcharge: 1.15,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
];

const BL2200FONTS = [
  {
    name: "Helvetica",
    code: "Helvetica",
    path: "/fonts/GT-Helvetica_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.815,
  },
  {
    name: "Americana Bold",
    code: "Americana_Bold",
    path: "/fonts/GT-Americana_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.99,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Arial",
    code: "Arial",
    path: "/fonts/GT-Arial_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.755,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Arial Bold",
    code: "Arial_Bold",
    path: "/fonts/GT-Arial_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.755,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Avant Garde Medium",
    code: "Avant_Garde_Medium",
    path: "/fonts/GT-Avant_Garde_Medium_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.777,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Clarendon Medium",
    code: "Clarendon_Medium",
    path: "/fonts/GT-Clarendon_Medium_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.852,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Copperplate",
    code: "Copperplate",
    path: "/fonts/GT-Copperplate_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Eurostyle Bold Externded",
    code: "Eurostyle_Bold_Extended",
    path: "/fonts/GT-Eurostyle_Bold_Ext_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Friz Quadtrata",
    code: "Friz_Quadrata",
    path: "/fonts/GT-Friz_Quadrata_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.743,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Futura",
    code: "Futura",
    path: "/fonts/GT-Futura_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.752,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Futura_Bold",
    code: "Futura_Bold",
    path: "/fonts/GT-Futura_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.875,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Garamond Bold",
    code: "Garamond_Bold",
    path: "/fonts/GT-Garamond_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Garamond Regular",
    code: "Garamond_Regular",
    path: "/fonts/GT-Garamond_Regular_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Gil Sans Bold",
    code: "Gil_Sans_Bold",
    path: "/fonts/GT-Gil_Sans_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Goudy Extra Bold",
    code: "Goudy_Extra_Bold",
    path: "/fonts/GT-GoudyExtraBold_v2.ttf",
    format: "truetype",
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    upcharge: 1.2,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Helvetica Bold",
    code: "Helvetica_Bold",
    path: "/fonts/GT-Helvetica_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.96,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Helvetica Bold Extended",
    code: "Helvetica_Bold_Extended",
    path: "/fonts/GT-Helvetica_Bold_Ext_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Helvetica Medium Condensed",
    code: "Helvetica_Medium_Condensed",
    path: "/fonts/GT-Helvetica_Medium_Cond_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.674,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Helvetica Light",
    code: "Helvetica_Light",
    path: "/fonts/GT-Helvetica_Light.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Helvetica Medium_Italic",
    code: "Helvetica_Medium_Italic",
    path: "/fonts/GT-Helvetica_Medium_Italic_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Kabel",
    code: "Kabel",
    path: "/fonts/GT-Kabel_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Optima",
    code: "Optima",
    path: "/fonts/GT-Optima_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.686,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Optima Semi Bold",
    code: "Optima_Semi_Bold",
    path: "/fonts/GT-Optima_Semibold_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.645,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Palatino",
    code: "Palatino",
    path: "/fonts/GT-Palatino_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.746,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Palatino Semi Bold",
    code: "Palatino_Semi_Bold",
    path: "/fonts/GT-Palatino_Semibold_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.768,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Ribbon",
    code: "Ribbon",
    path: "/fonts/GT-Ribbon_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Ribbon Deep",
    code: "Ribbon_Deep",
    path: "/fonts/GT-Ribbon_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Ribbon Condensed",
    code: "Ribbon_Condensed",
    path: "/fonts/GT-Ribbon_Condensed_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Roffe",
    code: "Roffe",
    path: "/fonts/GT-Roffe_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Roman",
    code: "Roman",
    path: "/fonts/GT-Roman_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.763,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Standard Block",
    code: "Standard_Block",
    path: "/fonts/GT-Standard_Block_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.644,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Times Bold",
    code: "Times_Bold",
    path: "/fonts/GT-Times_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.95,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Times New Roman",
    code: "Times_New_Roman",
    path: "/fonts/GT-Times_New_Roman_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset:
      "ABCDEFGHIJKLMNOPQRSTUVQXYZabcdefghijklmnopqrstuvwxyz0123456789,.'&\\-$* \\s",
    fontAdjustment: 0.95,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Twentieth Century",
    code: "Twentieth_Century",
    path: "/fonts/GT-Twentieth_Century.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
  {
    name: "Univers 67",
    code: "Univers_67",
    path: "/fonts/GT-Univers_67_v2.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: "ABCDEFGHIJKLMNOPQRSTUVQXYZZ0123456789,.'&\\-$* \\s",
    fontAdjustment: 1.0,
    charWidths: CHARWIDTHS,
  },
];

export const FONTS_MAP = {
  BL1000: BL10FONTS,
  BL2000: BL2000FONTS,
  BL2200: BL2200FONTS,
  BL31000: FLATCUTFONTS,
  BL32000: FLATCUTFONTS,
  BL33000: FLATCUTFONTS,
  BL40100: FLATCUTFONTS,
  BL40200: FLATCUTFONTS,
  ML1000: MLFONTS,
  PFL100: FLATCUTFONTS,
  BL70100: FLATCUTFONTS,
  VL0200: FLATCUTFONTS,
  VL03000: FLATCUTFONTS,
};

export const getFontsByProductCode = (productCode) => {
  if (!productCode) {
    console.warn("No product code provided");
    return [];
  }
  const fonts = FONTS_MAP[productCode];
  if (!fonts) {
    console.warn(`No fonts defined for product code: ${productCode}`);
    return [];
  }
  return fonts;
};
